/**
 * Generic search utility for HACCP record tables.
 * Matches a search query against all user-visible fields of a record.
 */

const SKIP_SUFFIXES = ['Id'];
const SKIP_FIELDS = new Set(['id', 'createdAt', 'updatedAt']);

export function matchesSearchQuery<T extends Record<string, unknown>>(
  record: T,
  query: string,
  extraFields?: string[]
): boolean {
  if (!query) return true;

  const lowerQuery = query.toLowerCase();

  // Check extra (resolved/joined) fields first
  if (extraFields) {
    for (const field of extraFields) {
      if (field && field.toLowerCase().includes(lowerQuery)) return true;
    }
  }

  // Check all top-level fields
  for (const [key, value] of Object.entries(record)) {
    if (SKIP_FIELDS.has(key)) continue;
    if (SKIP_SUFFIXES.some(suffix => key.endsWith(suffix))) continue;
    if (value == null) continue;

    if (typeof value === 'string') {
      if (value.toLowerCase().includes(lowerQuery)) return true;
    } else if (typeof value === 'number') {
      if (String(value).includes(lowerQuery)) return true;
    }
  }

  return false;
}
